export const adjustDimensionsFromFrame = (
  frameDimensions: string | undefined | null
): { x: number; y: number } => {
  if (!frameDimensions) {
    return { x: 720, y: 576 };
  }
  const [width, height] = frameDimensions.split(" x ").map(Number);
  if (!width || !height) {
    return { x: 720, y: 576 };
  }
  const aspectRatio = height / width;
  return { x: 720, y: Math.round(720 * aspectRatio) };
};

export const transformNormalizedToPixelCoordinates = (
  coordinates: number[][][],
  width: number,
  height: number
): number[][][] =>
  coordinates.map((polygon) =>
    polygon.map(([x, y]) => [x * width, y * height])
  );

export const transformPixelToNormalizedCoordinates = (
  coordinates: number[][][],
  width: number,
  height: number
): number[][][] =>
  coordinates.map((polygon) =>
    polygon.map(([x, y]) => [x / width, y / height])
  );

export const assignmentsToPreviewZones = (
  assignments: {
    localId: string;
    color: string;
    coordinates: number[][][];
  }[]
) =>
  assignments
    .filter((a) => a.coordinates.length > 0)
    .map((assignment) => ({
      label: assignment.localId,
      line_color: assignment.color,
      coordinates: assignment.coordinates,
    }));
